// hooks/useDuplicatePatientCheck.js
import { useMemo } from "react";
import {
  checkDuplicatePatient,
  getDuplicatePatient,
} from "../classes/utils/PatientUtils";

export const useDuplicatePatientCheck = patientList => {
  return useMemo(() => {
    return newPatient => checkDuplicatePatient(patientList || [], newPatient);
  }, [patientList]);
};

export const useGetDuplicatePatient = patientList => {
  return useMemo(() => {
    return newPatient => getDuplicatePatient(patientList || [], newPatient);
  }, [patientList]);
};
